// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"c8bc0447","513":"7d99a8cb","703":"3e9cabf6"}[chunkId] + ".chunk.js";
};